// extracted by mini-css-extract-plugin
export default {"Main":"confirmation__Main__svdis"};